import {useEffect} from 'react';

export default function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (evt) => {
      if (!ref.current || ref.current.contains(evt.target)) {
        return;
      }
      handler(evt);
    };
    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler]);
}
